


















import { Component, Vue } from 'vue-property-decorator'

interface ballType {
  img: string,
  size: number,
  x?: number,
  y?: number,
  zIndex: number
}

@Component({
  name: 'Canvas'
})

export default class expand extends Vue {
  innerWidth = window.innerWidth
  ctx = ''
  ballList: Array<ballType> = []
  map = {
    1: { x: 300, y: 250 },
    2: { x: -400, y: 300 },
    3: { x: -10, y: -230 },
    4: { x: -240, y: 0 },
    5: { x: 200, y: -400 },
    6: { x: -100, y: 300 },
    7: { x: -400, y: -400 },
    8: { x: 300, y: 0 }
  }

  created () {
    if (innerWidth <= 480) {
      this.map = {
        1: { x: 250, y: 300 },
        2: { x: -250, y: 300 },
        3: { x: 0, y: -300 },
        4: { x: -250, y: 0 },
        5: { x: 250, y: -300 },
        6: { x: 0, y: 300 },
        7: { x: -250, y: -300 },
        8: { x: 250, y: 0 }
      }
    }
  }

  mounted () {
    this.init()
    setTimeout(() => {
      this.expand()
    }, 300)
  }

  random (min, max) {
    return parseInt(Math.random() * (max - min) + min)
  }

  expand () {
    for (let i = 0; i < this.ballList.length; i++) {
      if (i !== 0) {
        setTimeout(() => {
          this.$set(this.ballList[i], 'x', this.map[i].x)
          this.$set(this.ballList[i], 'y', this.map[i].y)
        }, i + 100)
      }
    }
  }

  // 初始化小球随机大小
  init () {
    let min = 120
    let max = 160
    if (this.innerWidth > 480 && this.innerWidth <= 1024) {
      min = 100
      max = 140
    }
    this.ballList = [
      { img: require('../images/9.png'), size: this.innerWidth <= 480 ? 120 : 160, zIndex: 30 }, // 第一个在中间
      { img: require('../images/2.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/3.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/4.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/5.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/6.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/7.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/8.png'), size: this.random(min, max), zIndex: this.random(11, 22) },
      { img: require('../images/1.png'), size: this.random(min, max), zIndex: this.random(11, 22) }
    ]
    console.log(this.ballList)
  }
}
